export default {"src":"/_next/static/media/icon-facebook-circle.eda8b094.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};